// extracted by mini-css-extract-plugin
export default {"container":"LoadingView_container__8yGnw"};